import {
  FlatIconAndText2Row,
  RowText,
  SelectInput,
  TextInput,
  UploadComponent
} from "../../../../../../component/index.jsx"
import React, { useEffect, useState, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getVarietyFilterCertification } from "../../../../../../redux/actions/SubmissionAction.jsx"
import { ICON_CONSTANTS } from "../../../../../../constants/ImageConstants.js"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import { Button } from "react-bootstrap"
import { AlertInfo } from "../../../../../../component/atoms/AlertInfo/index.jsx"
import {
  stringFormatting,
  convertDigits,
  toHectare,
  toMeter
} from "../../../../../helpers/TextHelper.js"
import { ModalMap } from "../../../../../../component/atoms/ModalMap/index.jsx"
import { Card } from "react-bootstrap"
import { RowModule } from "../../../../../../component/atoms/RowModule/RowModule.jsx"
import { FormikProvider } from "formik"
import { AddImage, UploadIcon } from "../../../../../../component/atoms/Icons/SVG/upload.jsx"
import { UPLOAD } from "../../../../../../constants/InitTypeConstants.js"
import {
  resetUrlResponse,
  uploadAction,
  uploadImageListAction
} from "../../../../../../redux/actions/MasterDataAction.jsx"
import { DATE_TYPE_ENUM, GENDER_ENUM } from "../../../../../../constants/StringConstant.js"

export const FormulirSertification = ({
  formik,
  activeStep,
  setActiveStep,
  dataInit,
  isFormInitialized
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { Submission, MasterData, General } = useSelector((state) => state)

  const [openMap, setOpenMap] = useState(false)
  const [varietasList, setVarietasList] = useState([])
  const [seedClassList, setSeedClassList] = useState([])
  const [imageListFemale, setImageListFemale] = useState([])
  const [uploadType, setUploadType] = useState("")
  const [imageListMale, setImageListMale] = useState([])
  const [urlLocation, setUrlLocation] = useState("")
  const [loadingFemaleImage, setLoadingFemaleImage] = useState(false)
  const [loadingMaleImage, setLoadingMaleImage] = useState(false)
  const [loadingLocation, setLoadingLocation] = useState(false)
  const [selectPlantType, setSelectPlantType] = useState([])
  const [userEditedFemale, setUserEditedFemale] = useState(false)
  const [userEditedMale, setUserEditedMale] = useState(false)

  const currentVariety = useMemo(() => {
    if (!formik.values.variety_id || !dataInit?.variety_list) return null
    return dataInit.variety_list.find((item) => item.variety_id === formik.values.variety_id)
  }, [formik.values.variety_id, dataInit])

  const isFemaleEnabled = useMemo(() => {
    return currentVariety?.female_base_name !== null
  }, [currentVariety])

  const isMaleEnabled = useMemo(() => {
    return currentVariety?.male_base_name !== null
  }, [currentVariety])

  useEffect(() => {
    if (!formik.values.variety_id || !dataInit?.variety_list) {
      return
    }

    const selectedVariety = dataInit.variety_list.find(
      (item) => item.variety_id === formik.values.variety_id
    )

    if (!selectedVariety) return

    if (selectedVariety.female_base_name !== null && selectedVariety.female_total_seed !== null) {
      if (!userEditedFemale) {
        const calculatedFemaleSeed =
          Math.ceil((selectedVariety.female_total_seed * dataInit?.total_land_area_ha) / 4) * 4
        formik.setFieldValue("female_seed_total", calculatedFemaleSeed)
      }
    } else if (!isFormInitialized) {
      formik.setFieldValue("female_seed_total", 0)
      formik.setFieldValue("female_lot_number", "")
      formik.setFieldValue("female_seri_label", "")
    }

    if (selectedVariety.male_base_name !== null && selectedVariety.male_total_seed !== null) {
      if (!userEditedMale) {
        const calculatedMaleSeed = convertDigits(
          selectedVariety.male_total_seed * dataInit?.total_land_area_ha,
          0
        )
        formik.setFieldValue("male_seed_total", calculatedMaleSeed)
      }
    } else if (!isFormInitialized) {
      formik.setFieldValue("male_seed_total", 0)
      formik.setFieldValue("male_lot_number", "")
      formik.setFieldValue("male_seri_label", "")
    }
  }, [formik.values.variety_id])

  // Reset edit flags when variety changes
  useEffect(() => {
    setUserEditedFemale(false)
    setUserEditedMale(false)
  }, [formik.values.variety_id])

  // Sync varietasList from Redux
  useEffect(() => {
    if (Submission.filterVarietas && Submission.filterVarietas.length) {
      setVarietasList(
        Submission.filterVarietas.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )
    }
  }, [Submission.filterVarietas])

  // Sync seedClassList from Redux
  useEffect(() => {
    if (Submission.listSeedClass && Submission.listSeedClass.length) {
      setSeedClassList(
        Submission.listSeedClass.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )
    }
  }, [Submission.listSeedClass])

  // Handle upload responses
  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      if (!General.loading) {
        if (MasterData.uploadType === UPLOAD.AVATAR) {
          if (uploadType === GENDER_ENUM.FEMALE) {
            setImageListFemale([...imageListFemale, ...MasterData.urlResponseUpload])
            setLoadingFemaleImage(false)
          } else if (uploadType === GENDER_ENUM.MALE) {
            setImageListMale([...imageListMale, ...MasterData.urlResponseUpload])
            setLoadingMaleImage(false)
          } else {
            setUrlLocation(MasterData.urlResponseUpload)
            setLoadingLocation(false)
          }
        }
      }
      setTimeout(() => {
        dispatch(resetUrlResponse())
      }, 500)
    }
  }, [MasterData.urlResponseUpload, General.loading, MasterData.uploadType])

  // Initialize local state from formik values (for navigating back)
  useEffect(() => {
    setImageListFemale(formik.values.female_label_images || [])
    setImageListMale(formik.values.male_label_images || [])
    setUrlLocation(formik.values.location_image)
  }, [])

  // Sync image lists to formik
  useEffect(() => {
    formik.setFieldValue("female_label_images", imageListFemale)
  }, [imageListFemale])

  useEffect(() => {
    formik.setFieldValue("male_label_images", imageListMale)
  }, [imageListMale])

  useEffect(() => {
    formik.setFieldValue("location_image", urlLocation)
  }, [urlLocation])

  // Sync selectPlantType from Redux
  useEffect(() => {
    if (MasterData?.certificationPlanType) {
      setSelectPlantType(
        MasterData.certificationPlanType.map((value) => ({
          label: `${value.name}`,
          value: value.id
        }))
      )
    }
  }, [MasterData?.certificationPlanType])

  // Fetch variety list by plant type
  useEffect(() => {
    if (formik.values.plant_type_id) {
      dispatch(getVarietyFilterCertification(formik.values.plant_type_id))
    }
  }, [formik.values.plant_type_id])

  const onRemoveImageFemale = (i) => {
    const imgList = imageListFemale
    imgList.splice(i, 1)
    setImageListFemale([...imgList])
  }

  const onRemoveImageMale = (i) => {
    const imgList = imageListMale
    imgList.splice(i, 1)
    setImageListMale([...imgList])
  }

  const onChangeImageUploadFemale = (e) => {
    setLoadingFemaleImage(true)
    setUploadType(GENDER_ENUM.FEMALE)
    dispatch(uploadImageListAction({ data: e, type: UPLOAD.AVATAR }))
  }

  const onChangeImageUploadMale = (e) => {
    setLoadingMaleImage(true)
    setUploadType(GENDER_ENUM.MALE)
    dispatch(uploadImageListAction({ data: e, type: UPLOAD.AVATAR }))
  }

  const onChangeImageLocation = (e) => {
    setLoadingLocation(true)
    setUploadType("LOCATION")
    dispatch(uploadAction({ data: e, type: UPLOAD.AVATAR }))
  }

  const handleFemaleSeedTotalChange = (e) => {
    setUserEditedFemale(true)
    formik.handleChange(e)
  }

  const handleMaleSeedTotalChange = (e) => {
    setUserEditedMale(true)
    formik.handleChange(e)
  }

  const isFormValid = useMemo(() => {
    const baseValid =
      formik.values.variety_id &&
      formik.values.source_seed_class &&
      formik.values.male_planting_date &&
      formik.values.female_planting_date &&
      formik.values.location_image &&
      !loadingLocation &&
      formik.isValid

    if (!baseValid) return false

    if (isFemaleEnabled) {
      const femaleValid =
        formik.values.female_seed_total > 0 &&
        formik.values.female_lot_number &&
        formik.values.female_seri_label &&
        formik.values.female_label_images.length > 0 &&
        !loadingFemaleImage
      if (!femaleValid) return false
    }

    if (isMaleEnabled) {
      const maleValid =
        formik.values.male_seed_total > 0 &&
        formik.values.male_lot_number &&
        formik.values.male_seri_label &&
        formik.values.male_label_images.length > 0 &&
        !loadingMaleImage
      if (!maleValid) return false
    }

    return true
  }, [
    formik.values,
    formik.isValid,
    isFemaleEnabled,
    isMaleEnabled,
    loadingLocation,
    loadingFemaleImage,
    loadingMaleImage
  ])

  const dataArea = (
    <div className={"d-flex"}>
      {dataInit?.total_area} lahan{" "}
      <span className={"font-weight-normal ml-1 color-gray"}>
        <div className={"d-flex align-items-center"}>
          ({toMeter(dataInit?.total_land_area_meter)} / {toHectare(dataInit?.total_land_area_ha)})
        </div>
      </span>
    </div>
  )

  const overviewLahan = (
    <div className={"d-flex align-items-center bg-white rounded py-4 px-8 mb-4"}>
      <FlatIconAndText2Row
        rounded={true}
        title={t("label_total_area")}
        description={dataArea}
        svg={ICON_CONSTANTS.SUB_REGIONAL}
      />
      <FlatIconAndText2Row
        rounded={true}
        title={t("label_mitra")}
        description={dataInit?.mitra_name}
        svg={ICON_CONSTANTS.MITRA_2}
      />
      <FlatIconAndText2Row
        rounded={true}
        title={t("label_female_planting_date")}
        description={
          timeStampToDate(dataInit?.female_planting_start_date, DATE_TYPE_ENUM.ISO_DATE_ID) +
          " - " +
          timeStampToDate(dataInit?.female_planting_end_date, DATE_TYPE_ENUM.ISO_DATE_ID)
        }
        svg={ICON_CONSTANTS.CALENDER_BIG}
      />
      <Button
        onClick={() => setOpenMap(true)}
        className={
          "d-flex align-items-center color-blue underline text-capitalize font-size-lg font-weight-bolder"
        }
        variant={"text"}>
        {t("label_see_map")}
      </Button>
    </div>
  )

  const previousPlant = (
    <div className={"bg-white rounded p-8 mb-4"}>
      <h4 className={"mb-6 text-uppercase"}>{t("label_data_previous_plant")}</h4>
      <AlertInfo
        variant={"gray"}
        icon={ICON_CONSTANTS.INFO}
        label={t("label_data_from_area_bigger")}
        className={"mb-6"}
      />
      <RowModule customColumnCss={"col-md-6 mb-2"}>
        <RowText
          label={t("label_land_history")}
          value={stringFormatting(dataInit?.last_planting_data?.land_history)}
        />
        <RowText
          label={t("label_harvest_date")}
          value={stringFormatting(
            timeStampToDate(dataInit?.last_planting_data?.harvest_date, DATE_TYPE_ENUM.ISO_DATE_ID)
          )}
        />
        <RowText
          label={t("label_former_bero")}
          value={
            dataInit?.last_planting_data?.bero
              ? stringFormatting(dataInit?.last_planting_data?.bero) + " Bulan"
              : null
          }
        />
        <RowText
          label={t("label_disertifikasi")}
          value={
            dataInit?.last_planting_data?.certificate
              ? dataInit?.last_planting_data?.certificate
                ? "Ya"
                : "Tidak"
              : null
          }
        />
        <RowText
          label={t("label_plant_type")}
          value={stringFormatting(dataInit?.last_planting_data?.plant_type)}
        />
        <RowText
          label={t("label_seed_class")}
          value={stringFormatting(dataInit?.last_planting_data?.seed_class)}
        />
        <RowText
          label={t("label_varietas")}
          value={stringFormatting(dataInit?.last_planting_data?.variety_name)}
        />
        <RowText
          label={t("label_field_inspection")}
          value={stringFormatting(dataInit?.last_planting_data?.field_check)}
        />
      </RowModule>
    </div>
  )

  const detailSeed = (
    <Card className={"border-0 mb-10"}>
      <Card.Header className={"font-weight-bolder font-size-lg"}>
        1. {t("label_detail_seed")}
      </Card.Header>
      <Card.Body>
        <RowModule>
          <SelectInput
            name="plant_type_id"
            editable={true}
            label={t("label_plant_type")}
            placeholder={t("placeholder_choose_one")}
            options={selectPlantType}
            withoutFeedback={true}
            clearNow={true}
            value={formik.values.plant_type_id}
          />
        </RowModule>
        <RowModule>
          <SelectInput
            name="variety_id"
            required
            onChange={(value) => formik.setFieldValue("variety_id", value)}
            editable={true}
            label={t("label_varietas")}
            placeholder={t("placeholder_choose_variety")}
            value={formik.values.variety_id}
            options={varietasList}
          />
        </RowModule>
      </Card.Body>
    </Card>
  )

  const plantingDate = (
    <Card className={"border-0 mb-10"}>
      <Card.Header className={"font-weight-bolder font-size-lg"}>
        2. {t("label_planting_date")}
      </Card.Header>
      <Card.Body>
        <RowModule>
          <TextInput
            required
            editable={true}
            label={t("label_planting_male_date")}
            name="male_planting_date"
            type="date"
            placeholder={t("placeholder_select_planting_date")}
          />
        </RowModule>
        <RowModule>
          <TextInput
            required
            editable={true}
            label={t("label_planting_female_date")}
            name="female_planting_date"
            type="date"
            placeholder={t("placeholder_select_planting_date")}
          />
        </RowModule>
      </Card.Body>
    </Card>
  )

  const seedFrom = (
    <Card className={"border-0 mb-10"}>
      <Card.Header className={"font-weight-bolder font-size-lg"}>
        3. {t("label_seed_source")}
      </Card.Header>
      <Card.Body>
        <div className={"font-weight-bolder mb-6 mt-8"}>{t("label_seed_information")}</div>
        <RowModule>
          <TextInput
            type={"text"}
            name={"seed_base"}
            required
            editable={false}
            label={t("label_seed_source_origin")}
            value={currentVariety?.variety_source || "-"}
          />
        </RowModule>
        <RowModule>
          <SelectInput
            name="source_seed_class"
            required
            onChange={(value) => formik.setFieldValue("source_seed_class", value)}
            editable={true}
            label={t("label_seed_class")}
            placeholder={t("placeholder_select_seed_class")}
            value={formik.values.source_seed_class}
            options={seedClassList}
          />
        </RowModule>

        <div className={"font-weight-bolder mb-6 mt-8"}>Benih Betina</div>
        <RowModule>
          <RowModule>
            <TextInput
              name={"female_base_name"}
              required
              editable={false}
              label={t("label_base_seed_name")}
              value={currentVariety?.female_base_name || "-"}
            />
          </RowModule>
          <RowModule>
            <TextInput
              name={"female_seed_total"}
              required={isFemaleEnabled}
              editable={isFemaleEnabled}
              label={t("label_count_seed")}
              value={isFemaleEnabled ? formik.values.female_seed_total : ""}
              unit={isFemaleEnabled ? "Kg" : ""}
              placeholder={t("placeholder_input_count_seed")}
              onChange={handleFemaleSeedTotalChange}
            />
          </RowModule>
        </RowModule>
        <RowModule>
          <TextInput
            name={"female_lot_number"}
            type={"text"}
            required={isFemaleEnabled}
            editable={isFemaleEnabled}
            label={t("label_lot_number")}
            value={isFemaleEnabled ? formik.values.female_lot_number : ""}
            placeholder={t("placeholder_input_lot_number")}
          />
        </RowModule>
        <RowModule>
          <TextInput
            name={"female_seri_label"}
            type={"text"}
            required={isFemaleEnabled}
            editable={isFemaleEnabled}
            label={t("label_label_number")}
            value={isFemaleEnabled ? formik.values.female_seri_label : ""}
            placeholder={t("placeholder_input_label_number")}
          />
        </RowModule>
        {isFemaleEnabled && (
          <RowModule>
            <UploadComponent
              label={t("label_label_images")}
              subLabel={"(maks. 25 foto)"}
              required={true}
              name="female_label_images"
              onDeleteFileList={onRemoveImageFemale}
              fileList={imageListFemale}
              typeUpload={"image-list"}
              editable={true}
              onChange={onChangeImageUploadFemale}
              placeholder={<AddImage />}
              maxFile={25}
              isLoading={loadingFemaleImage}
            />
          </RowModule>
        )}

        <div className={"font-weight-bolder mb-6 mt-8"}>{t("label_male_seed")}</div>
        <RowModule>
          <RowModule>
            <TextInput
              name={"male_base_name"}
              required
              editable={false}
              label={t("label_base_seed_name")}
              value={currentVariety?.male_base_name || "-"}
            />
          </RowModule>
          <RowModule>
            <TextInput
              name={"male_seed_total"}
              required={isMaleEnabled}
              editable={isMaleEnabled}
              label={t("label_count_seed")}
              value={isMaleEnabled ? formik.values.male_seed_total : ""}
              unit={isMaleEnabled ? "Kg" : ""}
              placeholder={t("placeholder_input_count_seed")}
              onChange={handleMaleSeedTotalChange}
            />
          </RowModule>
        </RowModule>
        <RowModule>
          <TextInput
            name={"male_lot_number"}
            type={"text"}
            required={isMaleEnabled}
            editable={isMaleEnabled}
            label={t("label_no_lot")}
            value={isMaleEnabled ? formik.values.male_lot_number : ""}
            placeholder={t("placeholder_input_lot_number")}
          />
        </RowModule>
        <RowModule>
          <TextInput
            name={"male_seri_label"}
            type={"text"}
            required={isMaleEnabled}
            editable={isMaleEnabled}
            label={t("label_label_number")}
            value={isMaleEnabled ? formik.values.male_seri_label : ""}
            placeholder={t("placeholder_input_label_number")}
          />
        </RowModule>
        {isMaleEnabled && (
          <RowModule>
            <UploadComponent
              label={t("label_label_images")}
              subLabel={"(maks. 25 foto)"}
              required={true}
              name="male_label_images"
              onDeleteFileList={onRemoveImageMale}
              fileList={imageListMale}
              typeUpload={"image-list"}
              editable={true}
              onChange={onChangeImageUploadMale}
              placeholder={<AddImage />}
              maxFile={25}
              isLoading={loadingMaleImage}
            />
          </RowModule>
        )}

        <div className={"font-weight-bolder mb-6 mt-8"}>{t("label_total_count_seed")}</div>
        <RowModule>
          <TextInput
            name={"total_seed"}
            required
            editable={false}
            label={t("label_count_seed")}
            value={parseFloat(
              (
                (isFemaleEnabled ? parseFloat(formik.values.female_seed_total || 0) : 0) +
                (isMaleEnabled ? parseFloat(formik.values.male_seed_total || 0) : 0)
              ).toFixed(2)
            )}
          />
        </RowModule>
      </Card.Body>
    </Card>
  )

  const imageLocation = (
    <Card className={"border-0 mb-10"}>
      <Card.Header className={"font-weight-bolder font-size-lg"}>
        4. {t("label_location_image")}
      </Card.Header>
      <Card.Body>
        <RowModule>
          <div className={"position-relative"}>
            <UploadComponent
              required
              typeUpload={"image"}
              urlParsing={urlLocation}
              name="location_image"
              label={t("label_location_image")}
              editable={true}
              onChange={onChangeImageLocation}
              placeholder={<UploadIcon />}
              isLoading={loadingLocation}
            />
          </div>
        </RowModule>
      </Card.Body>
    </Card>
  )

  if (!dataInit) {
    return <div>Loading...</div>
  }

  return (
    <div className="d-flex justify-content-center w-full py-6">
      {dataInit?.areas.length > 0 && openMap && (
        <ModalMap
          open={openMap}
          setOpenMap={setOpenMap}
          areas={dataInit?.areas}
          centroid={dataInit?.centroid}
          mapTypeId={"terrain"}
        />
      )}

      <div className={"w-80vw"}>
        {overviewLahan}
        {previousPlant}
        <div className={"mt-20"}>
          <h4 className={"mb-10"}>{t("label_certification_form")}</h4>
          <FormikProvider value={formik}>
            {detailSeed}
            {plantingDate}
            {seedFrom}
            {imageLocation}
          </FormikProvider>
        </div>
        <div className={"d-flex justify-content-end align-items-center"}>
          <Button
            variant={"secondary"}
            onClick={() => setActiveStep(activeStep - 1)}
            className={"d-flex align-items-center color-primary mr-8"}>
            Kembali
          </Button>
          <Button
            disabled={!isFormValid}
            variant={"primary"}
            onClick={() => setActiveStep(activeStep + 1)}
            className={"d-flex align-items-center color-white"}>
            {t("button_submission_review")}
            <img src={ICON_CONSTANTS.ARROW_RIGHT_WHITE} className={"ml-2"} />
          </Button>
        </div>
      </div>
    </div>
  )
}
